module.exports = "/_next/static/images/b8779ec15481425c0699c597c6387a77-rewards-app-lg@3x.png";